import { useMemo } from 'react';

export default function ZonePolygonPreview({ polygon, color = '#3B82F6', size = 80 }) {
  // Convert polygon coordinates to SVG path
  const svgPath = useMemo(() => {
    if (!polygon?.coordinates || polygon.coordinates.length === 0) {
      return 'M 10,10 L 70,10 L 70,70 L 10,70 Z';
    }

    const coords = polygon.coordinates;

    // Find min/max to scale coordinates to SVG canvas
    let minX = coords[0][0];
    let maxX = coords[0][0];
    let minY = coords[0][1];
    let maxY = coords[0][1];

    coords.forEach(([x, y]) => {
      minX = Math.min(minX, x);
      maxX = Math.max(maxX, x);
      minY = Math.min(minY, y);
      maxY = Math.max(maxY, y);
    });

    const padding = 5;
    const width = Math.max(maxX - minX, 1);
    const height = Math.max(maxY - minY, 1);
    const scale = Math.min(
      (size - padding * 2) / width,
      (size - padding * 2) / height
    );

    // Convert to SVG coordinates
    const points = coords.map(([x, y]) => {
      const svgX = (x - minX) * scale + padding;
      const svgY = (y - minY) * scale + padding;
      return `${svgX},${svgY}`;
    });

    return `M ${points.join(' L ')} Z`;
  }, [polygon, size]);

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      className="bg-slate-100 rounded border border-slate-300"
    >
      {/* Background */}
      <rect width={size} height={size} fill="#f8fafc" />

      {/* Polygon */}
      <path
        d={svgPath}
        fill={color || '#3B82F6'}
        fillOpacity="0.3"
        stroke={color || '#3B82F6'}
        strokeWidth="1.5"
      />

      {/* Grid lines for reference */}
      <line x1="5" y1="5" x2={size - 5} y2="5" stroke="#e2e8f0" strokeWidth="0.5" />
      <line x1="5" y1={size - 5} x2={size - 5} y2={size - 5} stroke="#e2e8f0" strokeWidth="0.5" />
      <line x1="5" y1="5" x2="5" y2={size - 5} stroke="#e2e8f0" strokeWidth="0.5" />
      <line x1={size - 5} y1="5" x2={size - 5} y2={size - 5} stroke="#e2e8f0" strokeWidth="0.5" />
    </svg>
  );
}
